import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { EVENTS } from "@/const";

export default function useFileSize() {
  const checkFilesSize = (files: File[]) => {
    const unacceptedFiles = files.filter(file => file.size > config.maxUploadSize);
    if (unacceptedFiles.length) {
      emitter.emit(EVENTS.NOTIFICATION_SHOW, {
        text: $t("Your media {0} exceed file size limit and can't be uploaded", [
          unacceptedFiles.map(file => file.name).join(", "),
        ]),
        position: "top",
        timeout: 7000,
      });
      return files.filter(file => file.size <= config.maxUploadSize);
    }
    return files;
  };

  return { checkFilesSize };
}
